import { useQuery } from 'react-query';
import { url, suffixesToOptions, getSuffixes } from '@general/api/suffixesAPI';

const useSuffixOptions = () =>
    useQuery(url, getSuffixes({ transformData: suffixesToOptions }), {
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });

export default useSuffixOptions;
